export interface ObjectReference {
  id: string;
  name: string;
}

export const REASON_NOT_ON_CONTRACT = 'NOT_ON_CONTRACT';
export const REASON_EXCEEDS_QUANTITY = 'EXCEEDS_QUANTITY';

export const reasonLabels: Record<string, string> = {
  [REASON_NOT_ON_CONTRACT]: 'Not On Contract',
  [REASON_EXCEEDS_QUANTITY]: 'Exceeds SO Quantity',
};

export interface NotOnContractItem {
  id: string;
  name: string;
  type: string;
  vendor: string;
  service: string;
  reason: string;
  organization: ObjectReference;
  building: ObjectReference;
  // Populated for EXCEEDS_QUANTITY items (one per building and service)
  deliveredCount: number;
  contractedQuantity: number;
  devices: ObjectReference[];
  salesOrderLines: string[];
}

export type NotOnContractItems = NotOnContractItem[];
